const LOGO_URL = "/images/logo-reverse.png";
const SA_LOGO_URL = "/images/sa-logo-small-white.png";

const footerLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Industries", href: "#industries" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  const handleClick = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="footer"
      className="bg-slate-900 text-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Logo & Description */}
          <div className="space-y-4">
            <img
              src={LOGO_URL}
              alt="DigitalBlue Services"
              data-testid="footer-logo"
              className="h-14 w-auto"
            />
            <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
              Partnering with organisations to deliver reliable technology solutions
              and support long-term success.
            </p>
            <img
              src={SA_LOGO_URL}
              alt="South Australia"
              data-testid="footer-sa-logo"
              className="h-14 w-auto ml-2"
            />
          </div>

          {/* Quick Links */}
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-4">
              Navigation
            </p>
            <nav className="flex flex-col gap-3">
              {footerLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  data-testid={`footer-${link.label.toLowerCase()}-link`}
                  onClick={(e) => handleClick(e, link.href)}
                  className="text-sm text-slate-400 hover:text-white transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-4">
              Get in Touch
            </p>
            <div className="space-y-3">
              <a
                href="mailto:info@digitalblue.com.au"
                data-testid="footer-email"
                className="block text-sm text-slate-400 hover:text-white transition-colors"
              >
                info@digitalblue.com.au
              </a>
              <p className="text-sm text-slate-400">
                Adelaide, South Australia
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            &copy; {new Date().getFullYear()} DigitalBlue Services. All rights reserved.
          </p>
          <a
            href="https://www.digitalblue.com.au"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-website-link"
            className="text-xs text-slate-500 hover:text-slate-300 transition-colors"
          >
            digitalblue.com.au
          </a>
        </div>
      </div>
    </footer>
  );
}
